module.exports = __webpack_public_path__ + "static/sub-background-ec12ef093d312acb0dbba354b1b6fdca.png";